'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-13d783d6.js');
var React = require('react');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var Strikethrough = styled__default['default'].span.withConfig({ displayName: "ww-uikit_Strikethrough_kzpdh0cv", componentId: "sc-66meib" })(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    color: ", ";\n    text-decoration: line-through;\n    display: inline-block;\n    margin-right: 7px;\n\n    ", "\n"], ["\n    color: ", ";\n    text-decoration: line-through;\n    display: inline-block;\n    margin-right: 7px;\n\n    ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.charcoal100;
}, function (_a) {
    var sizeSelector = _a.sizeSelector;
    return sizeSelector && styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n            margin-right: 0;\n        "], ["\n            margin-right: 0;\n        "])));
});
var DiscountPrice = styled__default['default'].span.withConfig({ displayName: "ww-uikit_DiscountPrice_kzpdh0cv", componentId: "sc-ep86we" })(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n    color: ", ";\n    ", "\n"], ["\n    color: ", ";\n    ",
    "\n"])), function (_a) {
    var theme = _a.theme, color = _a.color;
    return color || theme.colors.charcoal50;
}, function (_a) {
    var sizeSelector = _a.sizeSelector;
    return sizeSelector && styled.css(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n            padding-left: 0;\n        "], ["\n            padding-left: 0;\n        "])));
});
var UVPText = styled__default['default'].span.withConfig({ displayName: "ww-uikit_UVPText_kzpdh0cw", componentId: "sc-1j7saxk" })(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n    margin-right: 5px;\n"], ["\n    margin-right: 5px;\n"])));
var PriceRendererWrapper = styled__default['default'].span.withConfig({ displayName: "ww-uikit_PriceRendererWrapper_kzpdh0cw", componentId: "sc-dydf4g" })(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n    &:not(:last-child) {\n        padding-right: 7px;\n    }\n"], ["\n    &:not(:last-child) {\n        padding-right: 7px;\n    }\n"])));
var PriceRenderer = function (_a) {
    var price = _a.price, props = tslib_es6.__rest(_a, ["price"]);
    return (React__default['default'].createElement(PriceRendererWrapper, tslib_es6.__assign({}, props), price));
};
var SpecialPriceRenderer = function (_a) {
    var price = _a.price, originalPrice = _a.originalPrice, discountColor = _a.discountColor, uvpText = _a.uvpText, testId = _a["data-testid"], sizeSelector = _a.sizeSelector, className = _a.className;
    return (React__default['default'].createElement(PriceRendererWrapper, { className: className },
        !!uvpText && React__default['default'].createElement(UVPText, null, uvpText),
        React__default['default'].createElement(Strikethrough, { sizeSelector: sizeSelector, "data-testid": "strike-through-price" }, originalPrice),
        React__default['default'].createElement(DiscountPrice, { sizeSelector: sizeSelector, "data-testid": testId, color: discountColor }, price)));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;

exports.PriceRenderer = PriceRenderer;
exports.SpecialPriceRenderer = SpecialPriceRenderer;
exports.default = PriceRenderer;
//# sourceMappingURL=index.js.map
